// import React, { useState, useEffect } from "react";
// import {
//   Button,
//   Popover,
//   OverlayTrigger,
//   Accordion,
//   Tooltip,
// } from "react-bootstrap";

// const ParentAgendaAccordianHeader = (props) => {
//   const { agenda, index, minutesCount } = props;
//   const [screenSize, setScreenSize] = useState(window.innerWidth);

//   useEffect(() => {
//     const handleResize = () => setScreenSize(window.innerWidth);
//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);
//   const tooltip = (attendee) => {
//     return (
//       <Tooltip id="tooltip">
//         {attendee.name} / {attendee?.email}
//       </Tooltip>
//     );
//   };
//   const popoverHoverFocus = (title) => {
//     return (
//       <Popover id="popover-basic" className="custom-popover">
//         <Popover.Body className="popover-body">{title}</Popover.Body>
//       </Popover>
//     );
//   };

//   return (
//     <Accordion.Header>
//       <div className="d-flex justify-content-between w-100">
//         <div className="d-flex justify-content-between">
//           {screenSize >= 360 && screenSize < 550 ? (
//             <>
//               {(() => {
//                 // Calculate slice length dynamically
//                 const baseLength = 32; // You can tweak this multiplier
//                 const sliceLength = Math.floor(screenSize / baseLength);

//                 const shortTitle =
//                   agenda?.title.length > sliceLength
//                     ? agenda?.title.slice(0, sliceLength) + "..."
//                     : agenda?.title;

//                 return (
//                   <OverlayTrigger
//                     trigger={["hover", "focus"]}
//                     placement="top"
//                     overlay={popoverHoverFocus(agenda?.title)}
//                   >
//                     <span className="pre-wrap-text">
//                       {`Agenda ${index + 1}: ${shortTitle}`}
//                     </span>
//                   </OverlayTrigger>
//                 );
//               })()}
//             </>
//           ) : screenSize > 550 && screenSize < 1199 ? (
//             <>
//               {(() => {
//                 // Calculate slice length dynamically
//                 const baseLength = 17; // You can tweak this multiplier
//                 const sliceLength = Math.floor(screenSize / baseLength);

//                 const shortTitle =
//                   agenda.title.length > sliceLength
//                     ? agenda.title.slice(0, sliceLength) + "..."
//                     : agenda.title;

//                 return (
//                   <OverlayTrigger
//                     trigger={["hover", "focus"]}
//                     placement="top"
//                     overlay={popoverHoverFocus(agenda.title)}
//                   >
//                     <span className="pre-wrap-text">
//                       {`Agenda ${index + 1}: ${shortTitle}`}
//                     </span>
//                   </OverlayTrigger>
//                 );
//               })()}
//             </>
//           ) : screenSize > 1199 && screenSize < 1400 ? (
//             <>
//               {(() => {
//                 // Calculate slice length dynamically
//                 const baseLength = 44; // You can tweak this multiplier
//                 const sliceLength = Math.floor(screenSize / baseLength);

//                 const shortTitle =
//                   agenda.title.length > sliceLength
//                     ? agenda.title.slice(0, sliceLength) + "..."
//                     : agenda.title;

//                 return (
//                   <OverlayTrigger
//                     trigger={["hover", "focus"]}
//                     placement="top"
//                     overlay={popoverHoverFocus(agenda.title)}
//                   >
//                     <span className="pre-wrap-text">
//                       {`Agenda ${index + 1}: ${shortTitle}`}
//                     </span>
//                   </OverlayTrigger>
//                 );
//               })()}
//             </>
//           ) : screenSize >= 1400 && screenSize < 1700 ? (
//             <>
//               {(() => {
//                 // Calculate slice length dynamically
//                 const baseLength = 37; // You can tweak this multiplier
//                 const sliceLength = Math.floor(screenSize / baseLength);

//                 const shortTitle =
//                   agenda.title.length > sliceLength
//                     ? agenda.title.slice(0, sliceLength) + "..."
//                     : agenda.title;

//                 return (
//                   <OverlayTrigger
//                     trigger={["hover", "focus"]}
//                     placement="top"
//                     overlay={popoverHoverFocus(agenda.title)}
//                   >
//                     <span className="pre-wrap-text">
//                       {`Agenda ${index + 1}: ${shortTitle}`}
//                     </span>
//                   </OverlayTrigger>
//                 );
//               })()}
//             </>
//           ) : (
//             <>
//               {(() => {
//                 // Calculate slice length dynamically
//                 const baseLength = 26; // You can tweak this multiplier
//                 const sliceLength = Math.floor(screenSize / baseLength);

//                 const shortTitle =
//                   agenda.title.length > sliceLength
//                     ? agenda.title.slice(0, sliceLength) + "..."
//                     : agenda.title;

//                 return (
//                   <OverlayTrigger
//                     trigger={["hover", "focus"]}
//                     placement="top"
//                     overlay={popoverHoverFocus(agenda.title)}
//                   >
//                     <span className="pre-wrap-text">
//                       {`Agenda ${index + 1}: ${shortTitle}`}
//                     </span>
//                   </OverlayTrigger>
//                 );
//               })()}
//             </>
//           )}
//         </div>
//         <div>
//           <span className="agenda-span badge">{minutesCount}</span>
//         </div>
//       </div>
//     </Accordion.Header>
//   );
// };

// export default ParentAgendaAccordianHeader;

import React, { useState, useEffect } from "react";
import {
  Popover,
  OverlayTrigger,
  Accordion,
  Tooltip,
} from "react-bootstrap";

const ParentAgendaAccordianHeader = ({ agenda, index, minutesCount }) => {
  const [screenSize, setScreenSize] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setScreenSize(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const tooltip = (attendee) => (
    <Tooltip id="tooltip">
      {attendee.name} / {attendee?.email}
    </Tooltip>
  );

  const popoverHoverFocus = (title) => (
    <Popover id="popover-basic" className="custom-popover">
      <Popover.Body className="popover-body">{title}</Popover.Body>
    </Popover>
  );

  const getBaseLength = () => {
    if (screenSize < 360) return 26;
    if (screenSize < 550) return 32;
    if (screenSize < 1199) return 17;
    if (screenSize < 1400) return 44;
    if (screenSize < 1700) return 37;
    return 26; // fallback
  };

  const baseLength = getBaseLength();
  const sliceLength = Math.floor(screenSize / baseLength);
  const shortTitle =
    agenda.title.length > sliceLength
      ? agenda.title.slice(0, sliceLength) + "..."
      : agenda.title;

  return (
    <Accordion.Header>
      <div className="d-flex justify-content-between w-100">
        <div className="d-flex justify-content-between">
          <OverlayTrigger
            trigger={["hover", "focus"]}
            placement="top"
            overlay={popoverHoverFocus(agenda.title)}
          >
            <span className="pre-wrap-text">
              {`Agenda ${index + 1}: ${shortTitle}`}
            </span>
          </OverlayTrigger>
        </div>
        <div>
          <span className="agenda-span badge">{minutesCount}</span>
        </div>
      </div>
    </Accordion.Header>
  );
};

export default ParentAgendaAccordianHeader;

